import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getDataFromCmsApi } from "../api/contentful-service";
import { parseHtml } from "../utils/utils";
import SubServicesContainer from "./sub-services/sub-services-container";
import Loader from "./loader";
import { Typography } from "@mui/material";
import FeeScheduleDoc from "./tax-collector/fee-schedule-doc";
import UnderstandTaxBillDoc from "./tax-collector/understand-tax-bill-doc";
import BulkTaxPaymentsCheckBox from "./tax-collector/bulk-tax-payments-check-box";

const DynamicPage = ({ webpageId, parentServiceId }) => {
    const [content, setContent] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch content based on webpageId passed as a prop
                const response = await getDataFromCmsApi(`webpage/${webpageId}`);

                if (response) {
                    setContent(response);
                } else {
                    setError("Content not found");
                }
            } catch (err) {
                console.error("Error fetching content:", err);
                setError("An error occurred while fetching data.");
            }
        };

        fetchData();
    }, [webpageId, parentServiceId]);

    if (error) {
        return <div>{error}</div>;
    }

    if (!content) {
        return <Loader />;
    }

    return (
        <div className="container py-5">
            <Typography variant="h3" className="text-center">
                {content.pageTitle}
            </Typography>

            {content.content && (
                <div
                    className={`${
                        webpageId === "taxCollectorClosureSchedule" &&
                        "closure-hours-table d-flex flex-column align-items-center"
                    } py-5`}
                    style={{ fontSize: "large" }}
                >
                    {parseHtml(content.content)}

                    {/* has to display custom components based on the webpage */}
                    {webpageId === "bulkTaxPayments" && <BulkTaxPaymentsCheckBox content={content.content} />}
                    {webpageId === "txcFeeSchedule" && <FeeScheduleDoc content={content} />}
                    {webpageId === "sampleAnnualSecuredTaxBill" && <UnderstandTaxBillDoc content={content} />}
                </div>
            )}

            {parentServiceId && <SubServicesContainer parentServiceId={parentServiceId} />}
        </div>
    );
};

DynamicPage.propTypes = {
    webpageId: PropTypes.string,
    parentServiceId: PropTypes.string
};

export default DynamicPage;
